const alertDialog = require('../alert-dialog/alert-dialog.js');

document.addEventListener("DOMContentLoaded", function () {
    const downloadButtonClass = "download-button";
    const downloadButtonHoveringDownloadClass = "hover-download";
    const downloadButtonLoadingClass = "downloading";
    const downloadButtonCompletedClass = "completed";
    const downloadButtonRemovingCompletedClass = "removing-completed";

    const _removeAllClassFromButton = function (e) {
        let _btn;
        if (e) {
            _btn = e.currentTarget;
        } else {
            _btn = document.getElementsByClassName(downloadButtonClass)[0];
        }

        if (_btn) {
            _btn.classList.remove(downloadButtonLoadingClass);
            _btn.classList.remove(downloadButtonCompletedClass);
            _btn.classList.remove(downloadButtonHoveringDownloadClass);
            _btn.classList.remove(downloadButtonRemovingCompletedClass);
        }
    }

    const _handleCompleteState = function (e) {
        const _btn = e.currentTarget;

        if (_btn) {
            _btn.classList.add(downloadButtonCompletedClass);

            setTimeout(() => {
                _removeAllClassFromButton(e);
                _btn.classList.add(downloadButtonRemovingCompletedClass);

                setTimeout(() => {
                    _removeAllClassFromButton(e);
                }, 500);

            }, 2000);
        }
    }

    const _clickDownloadButton = function (e) {
        if (e) {
            e.preventDefault();
        }

        const _btn = e.currentTarget;

        if (_btn) {
            const filename = _btn.download ?? 'file';

            _removeAllClassFromButton(e);
            _btn.classList.add(downloadButtonLoadingClass);
            alertDialog.showDtnaAlertDialog(null, `Downloading the ${filename}, could take a while...`, 10);

            const req = new XMLHttpRequest();
            req.responseType = "blob";
            req.open("GET", e.currentTarget.href, true);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    _removeAllClassFromButton();

                    if (req.status === 200) {
                        _handleCompleteState(e);

                        if (typeof window.chrome !== 'undefined') {
                            // Chrome version
                            var link = document.createElement('a');
                            link.href = window.URL.createObjectURL(req.response);
                            link.download = filename;
                            link.click();
                        } else if (typeof window.navigator.msSaveBlob !== 'undefined') {
                            // IE version
                            const contentType = xhr.getResponseHeader("Content-Type");
                            var blob = new Blob([req.response], { type: contentType });
                            window.navigator.msSaveBlob(blob, filename);
                        } else {
                            // Firefox version
                            var file = new File([req.response], filename, { type: 'application/force-download' });
                            window.open(URL.createObjectURL(file));
                        }
                    } else {
                        alertDialog.showDtnaAlertDialog('Error', `Downloading the ${filename} failed. Try again later.`, 0);
                    }
                }
            };
            req.send();
        }
    }

    const _handleMouseEnter = function (e) {
        const _btn = e.currentTarget;

        if (_btn) {
            _removeAllClassFromButton(e);

            setTimeout(() => {
                _btn.classList.add(downloadButtonHoveringDownloadClass);
            }, 0);
        }
    }

    const _handleMouseLeave = function (e) {
        const _btn = e.currentTarget;

        if (_btn) {
            _btn.classList.remove(downloadButtonHoveringDownloadClass);
        }
    }

    const _init = function () {
        const _elements = document.getElementsByClassName(downloadButtonClass);

        if (_elements) {
            for (let _element of _elements) {
                _element.removeEventListener('click', _clickDownloadButton);
                _element.removeEventListener('mouseleave', _handleMouseLeave);
                _element.removeEventListener('mouseenter', _handleMouseEnter);
                _element.addEventListener('click', _clickDownloadButton);
                _element.addEventListener('mouseleave', _handleMouseLeave);
                _element.addEventListener('mouseenter', _handleMouseEnter);
            }
        }
    }

    if (document.readyState == "complete") {
        _init();
    } else {
        window['addEventListener']("load", _init, 0);
    }
});
